module.exports = __webpack_public_path__ + "img/SYM08.4771c565.gif";